import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import UserFormCard from '../components/UserFormCard';
import * as userActions from '../actions/userActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';

class UserDetailScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.USERS,
            Breadcrumbs.USER_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.userActions.getUser(id);
    }

    componentDidUpdate(prevProps) {
        const { location, user: currentUser } = this.props;
        const { user: prevUser } = prevProps;

        if ( currentUser !== prevUser ) {
            const description = currentUser.name + ' ' + ( currentUser.last_name ? currentUser.last_name : '' );

            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.USER_DETAIL.id,
                url: location.pathname,
                description: description,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { user } = this.props;
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_USUARIO')} breadcrumbs={breadcrumbs}>
                {
                    user ? (
                        <UserFormCard user={user}/>
                    ) : null
                }
            </PsPage>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.users.users[ownProps.match.params.id],
    };
};

const mapDispatchToProps = dispatch => ( {
    userActions: bindActionCreators(userActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailScreen);



// WEBPACK FOOTER //
// ./src/app/users/screens/UserDetailScreen.jsx